import { render, staticRenderFns } from "./Changes.vue?vue&type=template&id=bbd5d480&scoped=true"
import script from "./Changes.vue?vue&type=script&lang=js"
export * from "./Changes.vue?vue&type=script&lang=js"
import style0 from "./Changes.vue?vue&type=style&index=0&id=bbd5d480&prod&lang=css"
import style1 from "./Changes.vue?vue&type=style&index=1&id=bbd5d480&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd5d480",
  null
  
)

export default component.exports